import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=287fa4c4&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=287fa4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287fa4c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287fa4c4')) {
      api.createRecord('287fa4c4', component.options)
    } else {
      api.reload('287fa4c4', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=287fa4c4&scoped=true&", function () {
      api.rerender('287fa4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/SearchResults.vue"
export default component.exports